import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook-solid",
  "use": "facebook-solid-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" aria-label=\"Facebook\" role=\"img\" viewBox=\"0 0 512 512\" id=\"facebook-solid\"><rect width=\"512\" height=\"512\" fill=\"#3b5998\" rx=\"15%\" /><path fill=\"#fff\" d=\"M287 456V157c0-21 6-35 35-35h38V59c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254H152v72h196\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol